//angular
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from '../../../../../../_shared/animations';
import { CompanyNotification } from 'src/app/_shared/models/notifications.model';
import { NotificationSectionValues } from 'src/app/app.data';
import { RestResponse } from '../../../../../../_shared/models';
import { SkeletonLoaderService } from '../../../../../../_core/services/index';
import { SettingsService } from '../../../_services/api/settings.service';
import { SharedIntegrationService } from 'src/app/_core/services/api/shared-integration.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', 'class': 'app-emails-template' },
  selector: 'app-emails',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})

export class NotificationsComponent implements OnInit, OnDestroy {
  collectionOfDunningForOnlinePayments: Array<CompanyNotification> = [];
  collectionOfInvalidPaymentMethods: Array<CompanyNotification> = [];
  collectionOfInvoiceReceipt: Array<CompanyNotification> = [];
  collectionOfOnBoardingEmails: Array<CompanyNotification> = [];
  collectionOfPaymentsAndCredits: Array<CompanyNotification> = [];
  collectionOfPaymentCollect: Array<CompanyNotification> = [];
  collectionOfSubscriptionActivation: Array<CompanyNotification> = [];
  collectionOfSubscriptionCancellations: Array<CompanyNotification> = [];
  collectionOfSubscriptionChanges: Array<CompanyNotification> = [];
  collectionOfSubscriptionRenewalReminders: Array<CompanyNotification> = [];
  collectionOfCustomerOnBoardingEmails: Array<CompanyNotification> = [];
  collectionOfCustomerPaymentMethods: Array<CompanyNotification> = [];
  collectionOfAutomaticProcess: Array<CompanyNotification> = [];
  collectionOfAvailableChannels: Array<any> = [];

  isCustomerOnBoardingEmailsReady: boolean = false;
  isCustomerCustomerPaymentMethodsReady: boolean = false;
  isOnBoardingEmailsReady: boolean = false;
  isSubscriptionActivationReady: boolean = false;
  isSubscriptionChangesReady: boolean = false;
  isSubscriptionRenewalRemindersReady: boolean = false;
  isPaymentsAndCreditsReady: boolean = false;
  isInvoiceReceiptReady: boolean = false;
  isPaymentFailuresReady: boolean = false;
  isDunningForOnlinePaymentsReady: boolean = false;
  isInvalidPaymentMethodsReady: boolean = false;
  isSubscriptionCancellationsReady: boolean = false;
  isAutomaticProcessReady: boolean = false;
  isAvailableChannelsReady: boolean = false;
  private subs = new Unsubscriber();
  notificationManager = {
      [NotificationSectionValues.companyNotifications]: {} as any,
      [NotificationSectionValues.customNotifications]: {} as any,
      [NotificationSectionValues.customerOnBoardingEmails]: {} as any,
      [NotificationSectionValues.customerPaymentMethods]: {} as any,
      [NotificationSectionValues.onBoardingEmails]: {} as any,
      [NotificationSectionValues.dunningForOnlinePayments]: {} as any,
      [NotificationSectionValues.dunningForOfflinePayments]: {} as any,
      [NotificationSectionValues.futureSubscriptionReminders]: {} as any,
      [NotificationSectionValues.invalidPaymentMethods]: {} as any,
      [NotificationSectionValues.invoiceReceipt]: {} as any,
      [NotificationSectionValues.onBoardingNotifications]: {} as any,
      [NotificationSectionValues.paymentsAndCredits]: {} as any,
      [NotificationSectionValues.paymentMethod]: {} as any,
      [NotificationSectionValues.paymentCollect]: {} as any,
      [NotificationSectionValues.selfServePortalAccountManagement]: {} as any,
      [NotificationSectionValues.standardNotifications]: {} as any,
      [NotificationSectionValues.subscriptionActivation]: {} as any,
      [NotificationSectionValues.subscriptionCancellations]: {} as any,
      [NotificationSectionValues.subscriptionChanges]: {} as any,
      [NotificationSectionValues.subscriptionRenewalReminders]: {} as any,
      [NotificationSectionValues.automaticProcess]: {} as any,
      };

  @Input() _notificationSectionValues = NotificationSectionValues;

  constructor(
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _sanitizer: DomSanitizer,
    public _skeleton: SkeletonLoaderService,
    private settingsService: SettingsService,
    private sharedIntegrationService: SharedIntegrationService,
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-bullet', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-bullet-01.svg'));
    this._iconRegistry.addSvgIcon('ico-disabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-03.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-02.svg'));
    this._iconRegistry.addSvgIcon('ico-enabled', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-05.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-02.svg'));
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-preview', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-wizard-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-switch', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-01.svg'));
  }

  getSubscriptionManagementNotifications(){
    // onBoardingEmails
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.onBoardingEmails).subscribe(
      (res: RestResponse) => {
        this.collectionOfOnBoardingEmails = <Array<CompanyNotification>>res.data;
        this.isOnBoardingEmailsReady = true;
      },
      (err: RestResponse) => {
        this.isOnBoardingEmailsReady = true;
        this._meta.showNotification(err);
      }
    );
    // subscriptionChanges
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.subscriptionChanges).subscribe(
      (res: RestResponse) => {
        this.collectionOfSubscriptionChanges = <Array<CompanyNotification>>res.data;
        this.isSubscriptionChangesReady = true;
      },
      (err: RestResponse) => {
        this.isSubscriptionChangesReady = true;
        this._meta.showNotification(err);
      }
    );
    // subscriptionRenewalReminders
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.subscriptionRenewalReminders).subscribe(
      (res: RestResponse) => {
        this.collectionOfSubscriptionRenewalReminders = <Array<CompanyNotification>>res.data;
        this.isSubscriptionRenewalRemindersReady = true;
      },
      (err: RestResponse) => {
        this.isSubscriptionRenewalRemindersReady = true;
        this._meta.showNotification(err);
      }
    );
    // subscriptionActivation
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.subscriptionActivation).subscribe(
      (res: RestResponse) => {
        this.collectionOfSubscriptionActivation = <Array<CompanyNotification>>res.data;
        this.isSubscriptionActivationReady = true;
      },
      (err: RestResponse) => {
        this.isSubscriptionActivationReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getInvoicesAndPaymentsNotifications() {
    // payments
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.paymentsAndCredits).subscribe(
      (res: RestResponse) => {
        this.collectionOfPaymentsAndCredits = <Array<CompanyNotification>>res.data;
        this.isPaymentsAndCreditsReady = true;
      },
      (err: RestResponse) => {
        this.isPaymentsAndCreditsReady = true;
        this._meta.showNotification(err);
      }
    );
    // invoices
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.invoiceReceipt).subscribe(
      (res: RestResponse) => {
        this.collectionOfInvoiceReceipt = <Array<CompanyNotification>>res.data;
        this.isInvoiceReceiptReady = true;
      },
      (err: RestResponse) => {
        this.isInvoiceReceiptReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getRevenueRecoveryNotifications() {
    // paymentCollect
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.paymentCollect).subscribe(
      (res: RestResponse) => {
        this.collectionOfPaymentCollect = <Array<CompanyNotification>>res.data;
        this.isPaymentFailuresReady = true;
      },
      (err: RestResponse) => {
        this.isPaymentFailuresReady = true;
        this._meta.showNotification(err);
      }
    );
    // dunningForOnlinePayments
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.dunningForOnlinePayments).subscribe(
      (res: RestResponse) => {
        this.collectionOfDunningForOnlinePayments = <Array<CompanyNotification>>res.data;
        this.isDunningForOnlinePaymentsReady = true;
      },
      (err: RestResponse) => {
        this.isDunningForOnlinePaymentsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getCustomerNotifications() {
    // onBoarding
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.customerOnBoardingEmails).subscribe(
      (res: RestResponse) => {
        this.collectionOfCustomerOnBoardingEmails = <Array<CompanyNotification>>res.data;
        this.isCustomerOnBoardingEmailsReady = true;
      },
      (err: RestResponse) => {
        this.isCustomerOnBoardingEmailsReady = true;
        this._meta.showNotification(err);
      }
    );
    // paymentMethod
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.customerPaymentMethods).subscribe(
      (res: RestResponse) => {
        this.collectionOfCustomerPaymentMethods = <Array<CompanyNotification>>res.data;
        this.isCustomerCustomerPaymentMethodsReady = true;
      },
      (err: RestResponse) => {
        this.isCustomerCustomerPaymentMethodsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getAutomaticOperations() {
    //automaticProcess
    this.subs.addSub = this.settingsService.getNotificationByKeyName(NotificationSectionValues.automaticProcess).subscribe(
      (res: RestResponse) => {
        this.collectionOfAutomaticProcess = <Array<CompanyNotification>>res.data;
        this.isAutomaticProcessReady = true;
      },
      (err: RestResponse) => {
        this.isAutomaticProcessReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  getAvailableChannels() {
    this.subs.addSub = this.sharedIntegrationService.getIntegrationByIntegrationType('email').subscribe(
      (res: RestResponse) => {
        this.collectionOfAvailableChannels.push(...<Array<any>>res.data);
        // filter repeated integration channels
        this.collectionOfAvailableChannels = [...new Map(this.collectionOfAvailableChannels.map(({gblIntegration}) => [gblIntegration?.keyName, gblIntegration])).values()];
        this.isAvailableChannelsReady = true;
      },
      (err: RestResponse) => {
        this.isAvailableChannelsReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  ngOnInit() {
    this.getSubscriptionManagementNotifications();
    this.getInvoicesAndPaymentsNotifications();
    this.getRevenueRecoveryNotifications();
    this.getCustomerNotifications();
    this.getAutomaticOperations();
    // this.getAvailableChannels();
  }

  getNotificationsByKeyName(_notificationSectionKeyName: string) {
     this.notificationManager[_notificationSectionKeyName].loading = true;
    this.subs.addSub = this.settingsService.getNotificationByKeyName(_notificationSectionKeyName).subscribe(
      (res: RestResponse) => {
        this.notificationManager[_notificationSectionKeyName].notifications = <Array<CompanyNotification>>res.data;
        this.notificationManager[_notificationSectionKeyName].loading = false;
      },
      (err: RestResponse) => {
        this.notificationManager[_notificationSectionKeyName].loading = false;
        this._meta.showNotification(err);
      }
    );
  }
  
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
